import { isDefined } from "@perxis-auto/shared";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { createAppSelector } from "../../shared/lib/store/createAppSelector.js";
import { selectCurrentEntity as selectCurrentEntity$1, selectAllFieldsByFormId } from "../stages/selectors.js";
const { selectAll, selectById, selectEntities, selectIds, selectTotal } = createEntityAdapter().getSelectors((state) => state.forms);
const selectState = (state) => state.forms;
const selectCurrent = createAppSelector(
  [selectCurrentEntity$1],
  (currentStage) => currentStage ? currentStage.form.id : null
);
const selectCurrentEntity = createAppSelector(
  [selectEntities, selectCurrent],
  (formsEntities, currentForm) => !!currentForm && formsEntities[currentForm] || null
);
const selectError = createAppSelector(selectCurrentEntity, (currentEntityForm) => currentEntityForm == null ? void 0 : currentEntityForm.error);
const selectLoading = createAppSelector(selectState, (formsState) => formsState.loading);
const selectFieldValueById = createAppSelector(
  [
    (_, { fieldId }) => fieldId,
    (state, { formId }) => selectById(state, formId)
  ],
  (fieldId, form) => {
    var _a;
    return ((_a = form == null ? void 0 : form.fields) == null ? void 0 : _a[fieldId]) ?? null;
  }
);
const selectDependFieldsByFieldId = createAppSelector(
  [(_, { fieldId }) => fieldId, selectAllFieldsByFormId],
  (fieldId, fields) => {
    const foundField = fields == null ? void 0 : fields.find((field) => field.id === fieldId);
    if (!fields || !foundField) {
      return null;
    }
    return fields.filter((field) => {
      var _a;
      return (_a = foundField.depends) == null ? void 0 : _a.includes(field.id);
    });
  }
);
const selectDependFieldValuesByFieldId = createAppSelector(
  [selectDependFieldsByFieldId, (state, { formId }) => selectById(state, formId)],
  (dependFields, form) => {
    if (!dependFields || !form) {
      return null;
    }
    const dependFieldIds = dependFields.map((field) => field.id);
    return Object.keys(form.fields).filter((field) => dependFieldIds.includes(field)).reduce(
      (dependFieldValues, key) => {
        const fieldId = key;
        return {
          ...dependFieldValues,
          [fieldId]: form.fields[fieldId]
        };
      },
      {}
    );
  }
);
const selectFieldIsMissingDependentFieldValuesById = createAppSelector(
  [selectDependFieldsByFieldId, selectDependFieldValuesByFieldId],
  (dependFields, dependFieldValues) => {
    if (!dependFields || !dependFieldValues) {
      return true;
    }
    return dependFields.some((field) => !isDefined(dependFieldValues[field.id]));
  }
);
export {
  selectAll,
  selectById,
  selectCurrent,
  selectCurrentEntity,
  selectDependFieldValuesByFieldId,
  selectDependFieldsByFieldId,
  selectEntities,
  selectError,
  selectFieldIsMissingDependentFieldValuesById,
  selectFieldValueById,
  selectIds,
  selectLoading,
  selectState,
  selectTotal
};
